// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__36yUw","filesListContainer":"PosDisputesFiles_filesListContainer__2at-p","filesButton":"PosDisputesFiles_filesButton__1PfGl"};